<template>
  <v-layout>
    <v-flex>
      <v-layout>
        <h1 class="headline pb-2">Supplier Contents</h1>
      </v-layout>
      <v-layout>
        <v-flex xs12>
          <v-card>
            <v-container grid-list-md fluid>
              <v-layout row wrap>
                <v-flex xs1 pt-3>
                  <v-menu offset-x bottom right>
                    <template v-slot:activator="{ on }">
                      <v-btn v-slot="on" icon text-xs-center>
                        <v-icon>{{
                          supplierTypeIcon(selectedSupplierType)
                        }}</v-icon>
                      </v-btn>
                    </template>
                    <v-card>
                      <v-list>
                        <v-list-item avatar>
                          <v-list-item-content>
                            <v-list-item-title
                              >Choose Supplier Type</v-list-item-title
                            >
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                      <v-divider></v-divider>
                      <v-container fluid grid-list-md>
                        <v-layout row wrap>
                          <v-radio-group v-model="selectedSupplierType">
                            <v-radio
                              v-for="sType in supplierTypes"
                              :key="sType"
                              :label="sType"
                              :value="sType"
                            ></v-radio>
                          </v-radio-group>
                        </v-layout>
                      </v-container>
                    </v-card>
                  </v-menu>
                </v-flex>
                <v-flex>
                  <destination-list-select
                    @onSelect="onDestinationSelect($event)"
                  ></destination-list-select>
                </v-flex>
                <v-flex>
                  <language-select
                    code="ENG"
                    @onSelect="onLanguageSelect($event)"
                  ></language-select>
                </v-flex>
                <v-flex>
                  <v-text-field
                    label="Supplier Name"
                    v-model="supplierName"
                  ></v-text-field>
                </v-flex>
                <v-flex>
                  <v-text-field
                    label="Service Name"
                    v-model="serviceName"
                  ></v-text-field>
                </v-flex>
                <v-flex>
                  <v-btn
                    block
                    :loading="loading"
                    :disabled="loading"
                    @click="onSearch"
                    class="mt-2"
                    color="primary"
                  >
                    <v-icon left>mdi-magnify</v-icon>Search
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
            <div v-if="debug">
              <p>Destination Id: {{ destinationId }}</p>
              <p>Supplier Name: {{ supplierName }}</p>
            </div>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-container fluid>
          <v-switch label="Show Images" v-model="showImages"></v-switch>
          <hr />
          <supplier-contens-item
            v-for="item in items"
            :show-images="showImages"
            :key="item.id"
            :item="item"
            :language-id="languageId"
            @reload="onReload"
          ></supplier-contens-item>
        </v-container>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import { SUPPLIER_TYPES } from "../../../../constants/supplierTypes";
import { SupplierTypeIconMixin } from "../../../../mixins/SupplierTypeIconMixin";
import DestinationListSelect from "../../shared/DestinationListSelect";
import { SUPPLIERS_CONTENT_SEARCH_QUERY } from "../../../../constants/graphql";
import SupplierContensItem from "./SupplierContentsItem";
import LanguageSelect from "../../shared/LanguageListSelect";
export default {
  name: "SupplierContens",
  mixins: [SupplierTypeIconMixin],
  components: {
    DestinationListSelect,
    SupplierContensItem,
    LanguageSelect,
  },
  data() {
    return {
      showImages: true,
      debug: false,
      loading: false,
      destinationId: "",
      supplierName: "",
      serviceName: "",
      items: [],
      suppliers: {},
      supplierTypes: SUPPLIER_TYPES,
      selectedSupplierType: "ACCOMMODATION",
      languageId: "",
    };
  },

  methods: {
    onDestinationSelect($event) {
      this.destinationId = $event.id;
    },
    onSearch() {
      this.loading = true;
    },
    onReload() {
      this.loading = true;
    },
    onLanguageSelect(payload) {
      this.languageId = payload;
    },
  },
  apollo: {
    suppliers: {
      query: SUPPLIERS_CONTENT_SEARCH_QUERY,
      variables() {
        return {
          filter: {
            name_contains: this.supplierName,
            destinationId: this.destinationId,
            serviceName: this.serviceName,
            service_type: this.selectedSupplierType,
          },
        };
      },
      result({ data, loader, networkStatus }) {
        this.items = data.suppliers.edges.map((node) => ({ ...node.node }));
        this.loading = false;
      },
      skip() {
        return !this.loading;
      },
      fetchPolicy: "network-only",
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/plugins/supplier-contents/SupplierContents.vue